import React, { useEffect, useState } from 'react';
import { Breadcrumb, Card, Col, Row, Badge, Spinner, Alert } from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { formatGanttDateTime } from './ganttHelpers';

const MobileGanttStrip = () => {
    const { accessToken, userId } = useAuth();
    const navigate = useNavigate();
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!userId || !accessToken) return;

        const load = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await axios.get(
                    `${config.apiBASEURL}/TaskBoardRoutes/gantt/user/${userId}`,
                    { headers: { Authorization: `Bearer ${accessToken}` } }
                );
                setTasks(response.data?.tasks || []);
            } catch (err) {
                setError(err.response?.data?.message || 'Could not load timeline');
            } finally {
                setLoading(false);
            }
        };

        load();
    }, [userId, accessToken]);

    return (
        <div className="page-content mobile-gantt-strip">
            <Row className="body_content px-2">
                <Col xs={12} className="mb-3">
                    <Breadcrumb className="mb-0">
                        <Breadcrumb.Item
                            onClick={() => navigate(-1)}
                            style={{ cursor: 'pointer' }}
                        >
                            Back
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>My timeline</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>

                {loading && (
                    <Col xs={12} className="text-center py-4">
                        <Spinner animation="border" size="sm" />
                    </Col>
                )}

                {!loading && error && (
                    <Col xs={12}>
                        <Alert variant="danger" className="py-2 small">
                            {error}
                        </Alert>
                    </Col>
                )}

                {!loading && !error && tasks.length === 0 && (
                    <Col xs={12}>
                        <Alert variant="secondary" className="py-2 small mb-0">
                            No active tasks on your timeline.
                        </Alert>
                    </Col>
                )}

                {!loading &&
                    !error &&
                    tasks.map((task) => (
                        <Col xs={12} key={task.id} className="mb-2">
                            <Card
                                className="shadow-sm"
                                role="button"
                                onClick={() =>
                                    navigate(
                                        `/Graphe/dashboard/kanbanboard/${task.board_id}?card=${task.id}`
                                    )
                                }
                            >
                                <Card.Body className="py-2 px-3">
                                    <div className="d-flex justify-content-between align-items-start gap-2">
                                        <div>
                                            <strong className="small d-block">{task.title}</strong>
                                            <span className="text-muted" style={{ fontSize: '12px' }}>
                                                {task.project?.project_name || task.board_name}
                                            </span>
                                        </div>
                                        {task.deadline_at && (
                                            <span className="text-muted" style={{ fontSize: '12px' }}>
                                                {formatGanttDateTime(task.deadline_at)}
                                            </span>
                                        )}
                                    </div>
                                    <div className="mt-2 d-flex flex-wrap gap-1">
                                        <Badge bg="light" text="dark">
                                            {task.status}
                                        </Badge>
                                        {task.missed_deadline && (
                                            <Badge bg="danger">Overdue</Badge>
                                        )}
                                        {task.is_rework && (
                                            <Badge bg="warning" text="dark">
                                                Rework
                                            </Badge>
                                        )}
                                    </div>
                                    <div
                                        className="mt-2 rounded"
                                        style={{
                                            height: '6px',
                                            background: '#e9ecef',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: `${Math.min(100, task.progress || 30)}%`,
                                                height: '100%',
                                                background: task.missed_deadline ? '#dc3545' : '#0d6efd',
                                            }}
                                        />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
            </Row>
        </div>
    );
};

export default MobileGanttStrip;
